module.exports = "div.w3-container {\r\n    max-width: 400px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/trips/trip-payment-form/trip-payment-form.component.css
// module id = ./src/app/components/trips/trip-payment-form/trip-payment-form.component.css
// module chunks = main